



















import Modal from 'library/components/global/modals/modal'
import Wysiwyg from 'library/components/global/wysiwyg'
import SiteLogo from 'library/components/layout/site-logo'
import {
	EV_ERROR_BAD_AUTH
	EV_ERROR_OLD_TIMESTAMP
} from 'library/services/expert-voice/expert-voice-constants'
export default

	components: {
		Modal
		Wysiwyg
		SiteLogo
	}

	data: -> state: 'loading'
		
	computed:
		modalStates: -> @$store.state.globals.evModals?.states?[0]
		copy: ->
			copy = @modalStates[@state]
			if @state == 'loading' && (index = copy.indexOf('</p>'))
				spinner = ' <span class="icon-spinner"></span>'
				copy = copy.slice(0, index) + spinner + copy.slice(index)
			return copy

	methods:

		# State setting methods designed for external use
		setApprovedState: -> @state = 'approved'
		setDeniedState: -> @state = 'denied'
		setErrorState: -> @state = 'error'

		close: -> @$refs.modal.close()

